import React from 'react';
import { GUESSES_LIMIT } from '../../gameSettings';
import { arrayRange } from '../../utils';
import { memo } from 'react';

function ListOfGuesses({ validatedGuesses, currentGuess }) {
    const numberOfLetters = 5;
    return (
        <div className='guess-results'>
            {validatedGuesses.map((guess, index) => {
                return (
                    <p key={index} className={`guess`}>
                        {guess.map((item, index) => (
                            <span
                                key={index}
                                className={`cell ${
                                    item.status ? item.status : ''
                                }`}>
                                {item.letter}
                            </span>
                        ))}
                    </p>
                );
            })}

            {GUESSES_LIMIT - validatedGuesses.length >= 1 ? (
                <>
                    <p className={`guess current`}>
                        {arrayRange(0, 4, 1).map((i) => {
                            return (
                                <span
                                    key={i}
                                    className={`cell ${
                                        currentGuess[i] ? 'filled' : ''
                                    }`}>
                                    {currentGuess[i] || ''}
                                </span>
                            );
                        })}
                    </p>
                    {arrayRange(
                        0,
                        GUESSES_LIMIT - validatedGuesses.length - 2,
                        1
                    ).map((i) => (
                        <p className='guess' key={i}>
                            {arrayRange(0, numberOfLetters - 1, 1).map((i) => (
                                <span key={i} className='cell'></span>
                            ))}
                        </p>
                    ))}
                </>
            ) : null}
        </div>
    );
}

export default memo(ListOfGuesses);
